import { useRef } from 'react'

/**
 * Hook personalizado para criar uma versão debounced de uma função
 * @param callback Função a ser executada após o debounce
 * @param delay Tempo de espera em milissegundos
 * @returns Função debounced que aceita os mesmos parâmetros da função original
 */
function useDebounce<T extends (...args: any[]) => void>(
  callback: T,
  delay: number
) {
  const timeoutRef = useRef<number | null>(null)

  return useRef((...args: Parameters<T>) => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = window.setTimeout(() => {
      callback(...args)
    }, delay)
  }).current
}

export default useDebounce
